module.exports = __webpack_public_path__ + "static/media/funder-personality-definition.b15d6982.png";